/**
 * @vuepress
 * ---
 * title: file
 * ---
 */
import Transformer from '@/transformers/transformer'

/**
 * @class confirmTransformer
 * Cancel payload transformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */
class confirmTransformer extends Transformer {
  /**
   * Transform file to send
   *
   * @param file to send file
   *
   * @returns {Object} The transformed file
   */

  static send(file) {
    const formData = new FormData()
    formData.append('request_id', file.id)
    formData.append('confirmation_file', file.file)
    return formData
  }

}

export default confirmTransformer


// WEBPACK FOOTER //
// ./src/transformers/taxReceipt/confirmRequestCancel.js